export default [
  {
    path: 'advisor-students',
    name: 'advisor-students',
    component: () => import('@/views/pages/advisor-students/AdvisorStudents.vue'),
    meta: {
      pageTitle: 'My Students',
      breadcrumb: [
        {
          text: 'My Students',
        },
      ],
      resource: 'AdvisorStudent',
    },
  },
]
